import _ from 'lodash';
import { zoomOneProMonthlyPlanCodes, zoomOneProYearlyPlanCodes } from '@/common/constants';

export const PLAN_PRICE_CHANGE_UTILS = {
  planCodeGroupList: [zoomOneProMonthlyPlanCodes, zoomOneProYearlyPlanCodes],
  isConsiderPriceChangeCase(planCode) {
    return _.some(this.planCodeGroupList, (list) => _.includes(list, planCode));
  },
  getPlanListForPriceChange(planCode) {
    return _.find(this.planCodeGroupList, (list) => _.includes(list, planCode));
  },
  getOtherPlanCodeForPriceChange(planCode) {
    const planCodeList = this.getPlanListForPriceChange(planCode);
    return _.find(planCodeList, (p) => p !== planCode);
  },
};
